import { Directive } from '@angular/core';

@Directive({
  selector: '[appDisplayAnimations]',
  host: {
    'animate.leave': 'leaving',
    class: 'display-animations',
  },
})
export class DisplayAnimations {}
